__webpack_require__.p = "/tools/gobang/";